import React, { useMemo } from "react";
import { Flex, type FlexProps, Text } from "@chakra-ui/react";
import { Accordion } from "ui/accordion";
import { tableData } from "./data";

function ComparisonFeatures({ featureIndex, ...props }: { featureIndex: number } & FlexProps) {
  return (
    <Flex flexDir="column" borderRadius="small" gap="big" {...props}>
      {tableData.rows.map((row) => (
        <Flex key={row.rowHead} flexDir="column" gap="tiny" color="brand.text.light">
          <Text textStyle="caption1" fontWeight="bold">
            {row.rowHead}
          </Text>
          <Text textStyle="caption1">{row.rowData[featureIndex]}</Text>
        </Flex>
      ))}
    </Flex>
  );
}

export function ComparisonsAccordion() {
  const items = useMemo(
    () => [
      // Lead with AI Decisioning as first open item
      {
        title: tableData.head[2],
        content: <ComparisonFeatures featureIndex={2} />,
      },
      {
        title: tableData.head[0],
        content: <ComparisonFeatures featureIndex={0} />,
      },
      {
        title: tableData.head[1],
        content: <ComparisonFeatures featureIndex={1} />,
      },
    ],
    [],
  );

  return <Accordion items={items} />;
}
